import { useEffect, useState } from "react";

/**
 * Ob die Oberfläche gerade dunkel ist: ausdrücklich gewählt (`theme-dark` an <html>,
 * gesetzt in App.tsx) oder über die Systemeinstellung, solange nichts gewählt ist.
 */
export function useDarkTheme(): boolean {
  const [dark, setDark] = useState(isDark);
  useEffect(() => {
    const update = () => setDark(isDark());
    const media = window.matchMedia?.("(prefers-color-scheme: dark)");
    media?.addEventListener?.("change", update);
    const classes = new MutationObserver(update);
    classes.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => {
      media?.removeEventListener?.("change", update);
      classes.disconnect();
    };
  }, []);
  return dark;
}

function isDark(): boolean {
  const root = document.documentElement.classList;
  if (root.contains("theme-dark")) return true;
  if (root.contains("theme-light")) return false;
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}
